import { uniq } from 'lodash'

/* eslint-disable complexity */
export const valMin = (value, num) => {
  return value.length < num
}

export const valMax = (value, num) => {
  return value.length > num
}

export const handleChangeForm = (forms, name, value, directComponentError = false) => {
  let resultForms = { ...forms }
  const isSelect = forms[name].inputType === `Select`
  value = isSelect && value ? parseInt(value, 10) : value
  const { validations, min, max, useFormValue = false } = forms[name].rules

  if (value && min && valMin(value, min)) {
    return (resultForms = {
      ...resultForms,
      [name]: {
        ...forms[name],
        error: `Debe tener mínimo ${min} caracteres`,
        value,
      },
    })
  }

  if (value && max && valMax(value, max)) {
    return (resultForms = {
      ...resultForms,
      [name]: {
        ...forms[name],
        error: useFormValue ? null : `Debe tener máximo ${max} caracteres`,
        value: useFormValue ? value.slice(0, max) : value,
      },
    })
  }

  if (value && validations && validations.length > 0) {
    for (const validation of validations) {
      const { field, validateFunction, validationType, error, notAllowWrite } = validation
      const fieldToCompare = field ? forms[field].value : false
      const isValid = validateFunction(fieldToCompare, value)
      if (validationType === `equal` && isValid) {
        resultForms[field].error = ``
      }
      resultForms = {
        ...resultForms,
        [name]: {
          ...forms[name],
          error: !isValid ? error : directComponentError ? directComponentError : ``,
          value: !isValid && notAllowWrite ? forms[name].value : value,
        },
      }
      if (!isValid) {
        break
      }
    }
  } else {
    resultForms = {
      ...resultForms,
      [name]: {
        ...forms[name],
        error: directComponentError ? directComponentError : ``,
        value,
      },
    }
  }
  return resultForms
}

export const validateUrl = roles => {
  if (roles.includes(`Admin`)) {
    return `/admin/`
  }
  if (roles.includes(`Validator`)) {
    return `/usuario/`
  }
  if (roles.includes(`Provider`)) {
    return `/proveedor`
  }
  return `/not-found`
}

export const validateEmail = value => {
  // const invalidEmails = [`gmail.cl`, `hotmail.cl`]
  const invalidEmails = [`gmail.cl`]
  const invalid = invalidEmails.some(str => {
    return value.includes(str)
  })
  if (invalid) {
    return false
  }
  return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,9})+$/.test(value)
}
export const validateEqual = (firstValue, secondValue) => {
  return firstValue === secondValue
}

export const validatePassword = value => {
  return /^(?=.*[a-z])(?=.*[A-Z])(?=.*d)(?=.*[@$!%*?&])[A-Za-zd@$!%*?&]$/.test(value)
}
export const ValidateMayusula = value => {
  return /^(?=.*[A-Z])/.test(value)
}
export const ValidateMinuscula = value => {
  return /^(?=.*[a-z])/.test(value)
}
export const ValidateCaracterESpecial = value => {
  return /^(?=.*[@$!%*#?&.])/.test(value)
}
export const validateNumero = value => {
  return /^(?=.*[0-9])/.test(value)
}

export const validateOnlyNumbersAndLetters = value => {
  if (value === ``) return true
  return /^[a-zA-Z0-9]+$/.test(value)
}

export const validateOnlyNumbers = value => {
  if (value === ``) return true
  return /^\d+$/.test(value)
}

export const validateForm = form => {
  let nextIsValid = true
  Object.keys(form).forEach(name => {
    const { value, error, type, rules } = form[name]
    if (
      (rules?.required && (!value || (type === `Select` && value === -1))) ||
      (error && error.length > 0) ||
      (type === `multiSelect` && rules?.required && value.length === 0)
    ) {
      
      nextIsValid = false
    }
  })
  return nextIsValid
}

export function languagesValidation(
  {
    promotion_kind: { value: promotionKind },
    title: { value: title, messageLabel: titleLabel },
    short_description: { value: shortDesc, messageLabel: shortDescLabel },
    long_description: { value: longDesc, messageLabel: longDescLabel },
  },
  setError,
) {
  if (promotionKind === 2 || promotionKind === 3) {
    const loadedLanguages = uniq([
      ...Object.keys(title),
      ...Object.keys(shortDesc),
      ...Object.keys(longDesc),
    ])
    const langsTypes = loadedLanguages.map(abrv => {
      if (title[abrv] || shortDesc[abrv] || longDesc[abrv]) {
        return title[abrv] && shortDesc[abrv] && longDesc[abrv] ? `complete` : `noComplete`
      }
      return `empty`
    })
    const hasNoComplete = langsTypes.find(type => type === `noComplete`)
    const hasEmpty = langsTypes.find(type => type === `empty`)
    const hasCompleteEn = title.en && shortDesc.en && longDesc.en
    // si existe algun lenguage que tenga informacion pero no este completa
    if (hasNoComplete) {
      setError(
        `Todos los idiomas que contengan información,\ndeben tener ${titleLabel},\n${shortDescLabel} y ${longDescLabel}`,
      )
      return false
    }
    if (hasEmpty && !hasCompleteEn) {
      setError(
        `Si quiere publicar para turistas internacionales\nen cualquier idioma diferente al español debe\ncontar con información completa en tal idioma\no al menos en inglés.`,
      )
      return false
    }
    return true
  }
  if (promotionKind === 1) {
    if (title.es && shortDesc.es && longDesc.es) {
      return true
    } else {
      setError(
        `Antes de publicar para mercado nacional, la información en español debe estar completa.`,
      )
    }
  }
  return false
}

export const isNullOrUndefined = (prop, multilanguage = false, coin = undefined) => {
  if (coin) {
    const hasValue = Object.keys(prop).find(coin => prop[coin].from || prop[coin].to)
    return hasValue === undefined
  }
  if (multilanguage) {
    if (Object.keys(prop).length === 0) return true
    const hasAnyLanguage = Object.keys(prop).find(lang => prop[lang])
    return hasAnyLanguage === undefined
  }
  if (Array.isArray(prop)) {
    return prop.length === 0
  }
  return !prop || prop === -1
}
